import { RouteComponentProps } from '@gatsbyjs/reach-router';
import React from 'react';
import ConversionPage from '~/components/template/ConversionPage';

const DemoStrapiPages: React.FCC<RouteComponentProps<{ slug: string }>> = ({
  slug,
}) => <ConversionPage slug={slug ?? 'catch-all'} />;

export default DemoStrapiPages;
